<template>
   <div class="create-certificate container-fluid background-color-grey"> 
     <div id="myNav" class="overlay overlay-overall-width-100Perc">
     <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="closeUpdateCertificate($event)">
              <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
 
     <div class="row vertical-align padding-bottom-2Perc">
        <div class="col-md-1 col-lg-1">
        </div>  
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Automatically show certificates to Users
        </div>
        <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
          <div class="form-group">
            <div class="col-sm-12 padding-left-0Px">
              <input type="checkbox" v-model="allowViewCertificateValue" :disabled="!enableCertificationOption"/>
            </div>
          </div>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          # of Course Completion Count Required For Certificate
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px">
          <div class="form-group">
            <div class="col-sm-12 padding-left-0Px">
              <input type="number" placeholder="Count" class="form-control" v-model="getCourseCompletionCriteriaForCertificateValue"/>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-lg-3">
        </div>  
      </div>

      <div class="row vertical-align margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1">
        </div>  
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Upload Certificate
        </div>
        <div class="col-md-3 col-lg-3 padding-right-0Px">
          <p><input type="file" id="certificateFile" accept=".pdf" @change="enableOrDisableFileUrl" @blur="enableOrDisableFileUrl" @focus="enableOrDisableFileUrl"></p>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Certification Date
        </div>
        <div class="col-md-3 col-lg-3 padding-right-0Px">
          <input type="text" class="form-control" v-model="certificationDateValue">
        </div>
        <div class="col-md-1 col-lg-1">
        </div>  
      </div>
      
      <div class="row vertical-align margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1">
        </div>  
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Enable Certification
        </div>
        <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
          <div class="form-group">
            <div class="col-sm-12 padding-left-0Px">
              <input type="checkbox" v-model="enableCeritificationValue" :disabled="!enableCertificationOption"/>
            </div>
          </div>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Certificate Title
        </div>
        <div class="col-md-3 col-lg-3 padding-right-0Px">
          <input type="text" class="form-control" v-model="certificationTitleValue" :maxlength="constants.Certificate_Title_Max_Length">
        </div>
        <div class="col-md-1 col-lg-1 text-align-left">
          <div class="tooltip1">
            <img :src="iconInfo" alt="iconCopy" class="height-20Px width-20Px img-opacity cursor-pointer">
            <span class="tooltiptext1">{{constants.Certificate_Title_Tooltip}}</span> 
          </div>
        </div>  
      </div>

      <div class="row vertical-align margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1">
        </div>  
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
          Group Course(s) to Include
        </div>
        <div class="col-md-8 col-lg-8 padding-right-0Px text-align-left border-color-grey padding-top-1-perc padding-bottom-1-perc">
          <div class="form-group">
            <div class="col-sm-12 padding-left-0Px" v-for="groupCourseObj in getGroupCourseListValue" :key="groupCourseObj.GroupCourseMasterId" :grouCourseObj="groupCourseObj">
              <input type="checkbox" v-model="getGroupCourseMasterIdsValue" :value="groupCourseObj.GroupCourseMasterId"> {{titleToShow(groupCourseObj)}}
            </div>
            <div class="col-sm-12 padding-left-0Px font-size-15px" v-if="getGroupCourseListValue.length === 0">
              No Group courses found. 
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1">
        </div>  
      </div>
      <div class="row margin-bottom-2Perc">
        <div class="col-md-5 col-lg-5"></div>  
        <div class="col-md-2 col-lg-2">
          <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="AddCertificateOnServer">Add Certificate</button>
        </div>  
        <div class="col-md-5 col-lg-5"></div>  
      </div>
      <div class="row">
      </div> 
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>              
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmationAction"></confirmation-alert>
    </div> 
   </div>
   </div>
</template>
<script>
import iconInfo from '../../assets/images/iconinfoblue.png'
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import AlertBox from '@/components/AlertOverlay'
import EditProgressBucket from '@/components/EditProgressBucket'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'

export default {
  props: ['selectedGroupObj', 'groupCourseList'],
  name: 'create-certificate',
  created () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      iconInfo: iconInfo,
      constants: constants,
      enableCertificationOption: true,
      certInfo: {
        ParentId: '',
        EnableCertification: false,
        CertificateTitle: null,
        CertificationDate: null,
        GroupCourseMasterIds: [],
        AllowView: false,
        CompletionCriteriaForCertificate: 0
      },
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: '',
      postfixString: '',
      selectedOperation: '',
      selectedGroupCourseIds: []
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'edit-progress-bucket': EditProgressBucket
  },
  methods: {
    closeUpdateCertificate: function () {
      var objToReturn = {
        certificateObj: null,
        currentOperation: 'Close_Create_Certificate'
      }
      this.$emit('updatedValues', objToReturn)
    },
    checkCertificateFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    validateRequiredFieldBeforeSubmit: function () {
      var certificateFile = document.getElementById('certificateFile').files[0]
      if (parseInt(this.getCourseCompletionCriteriaForCertificateValue) > this.getGroupCourseMasterIdsValue.length) {
        this.showAlertDialog = true
        this.errorMsg = '\'# of Course Completion Count Required For Certificate\' value can\'t be greater than number of selected group course (i.e. ' + this.getGroupCourseMasterIdsValue.length + ') size.'
        return false
      } else if ((this.certificationDateValue === undefined || this.certificationDateValue === 'undefined' || this.certificationDateValue === null || this.certificationDateValue === 'null' || this.certificationDateValue === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Certification Date can\'t be empty.'
        return false
      } else if (this.certificationTitleValue === undefined || this.certificationTitleValue === 'undefined' || this.certificationTitleValue === null || this.certificationTitleValue === 'null' || this.certificationTitleValue === '') {
        this.showAlertDialog = true
        this.errorMsg = 'Certificate Title can\'t be empty.'
        return false
      } else if ((certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Please upload a certificate file.'
        return false
      } else if ((certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null) && (!this.checkCertificateFileExtesion(document.getElementById('certificateFile').value))) {
        this.showAlertDialog = true
        this.errorMsg = 'Only .pdf file is allowed for uploading a certificate.'
        return false
      } else if (this.getGroupCourseMasterIdsValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Atleast one Group Course required.'
        return false
      }
      return true
    },
    titleToShow: function (grouCourseObj) {
      var titleToReturn = ''
      /*
      if (grouCourseObj.DisplayTitle !== undefined && grouCourseObj.DisplayTitle !== 'undefined' && grouCourseObj.DisplayTitle !== null && grouCourseObj.DisplayTitle !== 'null' && grouCourseObj.DisplayTitle !== '') {
        titleToReturn = grouCourseObj.DisplayTitle
        if (grouCourseObj.DisplaySubTitle !== undefined && grouCourseObj.DisplaySubTitle !== 'undefined' && grouCourseObj.DisplaySubTitle !== null && grouCourseObj.DisplaySubTitle !== 'null' && grouCourseObj.DisplaySubTitle !== '') {
          titleToReturn += ' [' + grouCourseObj.DisplaySubTitle + ']'
        }
      } else {
        if (grouCourseObj.CourseTitle !== undefined && grouCourseObj.CourseTitle !== 'undefined' && grouCourseObj.CourseTitle !== null && grouCourseObj.CourseTitle !== 'null' && grouCourseObj.CourseTitle !== '') {
          titleToReturn = grouCourseObj.CourseTitle
          if (grouCourseObj.CourseSubTitle !== undefined && grouCourseObj.CourseSubTitle !== 'undefined' && grouCourseObj.CourseSubTitle !== null && grouCourseObj.CourseSubTitle !== 'null' && grouCourseObj.CourseSubTitle !== '') {
            titleToReturn += ' [' + grouCourseObj.CourseSubTitle + ']'
          }
        }
      }
      */
      // Requested given change by Rahul on 24/08/21
      titleToReturn = grouCourseObj.CourseTitle + ' [' + grouCourseObj.CourseSubTitle + ']'
      return titleToReturn
    },
    enableOrDisableFileUrl (event) {
      var file = document.getElementById('certificateFile').files[0]
      if (this.getCertificateUrlValue === null) {
        if (file !== undefined && file !== 'undefined' && file !== null && file !== 'null' && file !== '') {
          this.enableCertificationOption = true
          this.enableCeritificationValue = this.selectedGroupCourseIds !== undefined && this.selectedGroupCourseIds !== null && this.selectedGroupCourseIds.length > 0
        } else {
          this.certInfo.EnableCertification = false
          this.enableCertificationOption = false
        }
      } else {
        this.enableCertificationOption = true
      }
    },
    userConfirmationAction (value) {
      this.showConfirmationBox = false
      if (value) {}
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    setDefaultValues: function () {
      this.certInfo.ParentId = this.selectedGroupObj.GroupId
    },
    AddCertificateOnServer: function (event) {
      var _this = this
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (this.selectedGroupObj !== undefined || this.selectedGroupObj.length > 0) {
          // AK: Start Showing Spinner (ManageGroup file)
          _this.$emit('showSpinner', true)
          var certificateFile = document.getElementById('certificateFile').files[0]
          _this.certInfo.GroupCourseMasterIds = _this.getGroupCourseMasterIdsValue.join()
          const formData = new FormData()
          formData.append('CertInfo', JSON.stringify(_this.certInfo))
          formData.append('TemplateFile', certificateFile)
          groupService
              .addCertificate(storeObj.state.access_token, formData)
              .then(responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  var objToReturn = {
                    certificateObj: responseObj.data,
                    currentOperation: 'Create_Certificate'
                  }
                  _this.$emit('updatedValues', objToReturn)
                  _this.$emit('showSpinner', false)
                } else {
                  // AK: Hide Spinner
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg = 'Oops! Something went wrong. Please try again.'
                }
              }, errorObj => {
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              })
        } else {
          console.log(
            'Selected Group Object is NULL hence declined ADD CERTIFICATE OPERATION'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    allowViewCertificateValue: {
      get: function () {
        return this.certInfo.AllowView
      },
      set: function (newValue) {
        this.certInfo.AllowView = newValue
      }
    },
    getCourseCompletionCriteriaForCertificateValue: {
      get: function () {
        return this.certInfo.CompletionCriteriaForCertificate
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = '\'# of Course Completion Count Required For Certificate\' value can\'t be less than 0.'
            this.certInfo.CompletionCriteriaForCertificate = 0
          } else if (this.getGroupCourseMasterIdsValue.length === 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Atleast one Group Course is required to change \'# of Course Completion Count Required For Certificate\' value.'
            this.certInfo.CompletionCriteriaForCertificate = 0
          } else if (parseInt(newValue) > this.getGroupCourseMasterIdsValue.length) {
            this.showAlertDialog = true
            this.errorMsg = '\'# of Course Completion Count Required For Certificate\' value can\'t be greater than number of selected group course (i.e. ' + this.getGroupCourseMasterIdsValue.length + ') size.'
            this.certInfo.CompletionCriteriaForCertificate = this.getGroupCourseMasterIdsValue.length
          } else {
            this.certInfo.CompletionCriteriaForCertificate = parseInt(newValue)
          }
        } else {
          this.certInfo.CompletionCriteriaForCertificate = 0
        }
      }
    },
    getGroupCourseMasterIdsValue: {
      get: function () {
        return this.selectedGroupCourseIds
      },
      set: function (newValue) {
        this.selectedGroupCourseIds = newValue
      }
    },
    getGroupCourseListValue: {
      get: function () {
        return this.groupCourseList
      }
    },
    enableCeritificationValue: {
      get: function () {
        return this.certInfo.EnableCertification
      },
      set: function (newValue) {
        this.certInfo.EnableCertification = newValue
      }
    },
    getCertificateUrlValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateFile
        } else {
          return null
        }
      },
      set: function (newValue) {
        this.certInfo.Certificate = newValue
      }
    },
    getCertificateIdValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateId
        } else {
          return null
        }
      }
    },
    certificationDateValue: {
      get: function () {
        return this.certInfo.CertificationDate
      },
      set: function (newValue) {
        this.certInfo.CertificationDate = newValue
      }
    },
    certificationTitleValue: {
      get: function () {
        return this.certInfo.CertificateTitle
      },
      set: function (newValue) {
        this.certInfo.CertificateTitle = newValue
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
*/
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-15px {
  font-size: 14px;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-grey {
  border: 1px solid gainsboro;
}
.padding-top-1-perc {
  padding-top: 1%;
}
.padding-bottom-1-perc {
  padding-bottom: 1%;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-bottom-2Perc {
  padding-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
.margin-top-2Perc{
  margin-top:2%;
}
.padding-6px-7px {
  padding: 6px 7px;
}
.float-left {
  float: left;
}
.padding-left-0Px {
  padding-left: 0px;
}
.padding-right-0Px {
  padding-right: 0px;
}
.text-color-blue {
  color: blue;
}
.text-decoration-underline {
  text-decoration: underline;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
a:link{
  color: blue !important;
  text-decoration: none !important;
} 
a:visited{
  color: blue !important;
  text-decoration: none !important;
}
a:hover{
  color: blue !important;
  text-decoration: none !important;
}
a:active{
  color: blue !important;
  text-decoration: none !important;
}
a {
  color: blue !important;
  text-decoration: underline !important;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dddddd;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    font-size: 12px;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.height-20Px {
 height:20px; 
}
.width-20Px {
  width:20px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.background-color-grey {
  background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/group/CreateCertificate.vue